import Vue from 'vue';
import AlertComponent from './base-alert';
const AlertConstruction = Vue.extend(AlertComponent);


/***
 * 接受的配置项>>>
 *  type：       类型 success/error/... （同base-alert）
 *  content：    提示内容
 *  showIcon：   是否显示图标
 *  closable：   是否可以关闭
 * @param options
 * @constructor
 */
const Alert = function(options = {}) {
    let content = '',
        duration = options.hasOwnProperty('duration')?options.duration:5000;

    //如果只传递了一个字符串，则认定只想把当前字符串提示出去
    if (typeof options === 'string') {
        content = options;
    }else{
        content = options.content;
    }

    //构造一个alert组件的实例
    let instance = new AlertConstruction({
        data : function () {
            return {
                visible: true
            }
        },
        propsData: Object.assign({
            isTop: true
        }, options)
    });

    //将实例挂载到自己的vm模型中
    instance.$slots.default = [content];
    // instance.isTop = true;
    instance.vm = instance.$mount();

    //将实例真实插入到body中
    document.body.appendChild(instance.vm.$el);

    instance.dom = instance.vm.$el;
    if(duration){
        setTimeout(()=>{
            instance.visible = false;
        }, duration)
    }

    return instance.vm;
};


export default Alert;


// WEBPACK FOOTER //
// ./src/components/alert.js